import Vue from 'vue'
import App from './App.vue'
import store from "./../store/index.js";
import '../assets/style/core/variables/fonts.scss';

Vue.config.productionTip = false
import './popUp.scss';

const elementToMountInId = 'widget-popup';

const elementToMountIn = elementId => document.getElementById(elementId);

const getElementOptions = element => JSON.parse(element.getAttribute('options')) ?? {};

const createWidget = (elementId, options) => {
    new Vue({
        el: '#' + elementId,
        store,
        render(createElement) {
            return createElement(App, {
                props: {
                    options
                }
            });
        }
    });
};

const onBeforeExit = callback => {
    document.documentElement.addEventListener("mouseleave", callback)
}

const showNowOrOnExit = (elementId, options) => {
    if (options.mode === 'preview') {
        createWidget(elementId, options)
    } else {
        onBeforeExit(() => {
            createWidget(elementId, options)
        })
    }
};

showNowOrOnExit(
    elementToMountInId,
    getElementOptions(
        elementToMountIn(
            elementToMountInId)))
